// No full core-js import (large CJS + fragile under Terser). See vite `build.target`; use @vitejs/plugin-legacy for IE/old Safari if needed.

import "../styles/main.scss";

import "flickity-fullscreen/fullscreen.css";
import "flickity-fullscreen";
import "leaflet/dist/leaflet.css";

// Swiper carousel library.
// List of modules: https://swiperjs.com/swiper-api#using-js-modules
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

// Import A11y (accessibility) Dialog for megamenu.
// See https://a11y-dialog.netlify.app/
import A11yDialog from 'a11y-dialog';

// Import Bootstrap JS components one by one to reduce bundle size.
// See https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap
import { Dropdown, Popover } from 'bootstrap';

import vueComponents from "./lib/vueComponents";
import drawer from "./lib/drawer";
//import headroom from "./lib/headroom";
import modal from "./lib/modal";
import descriptionCollapse from "./lib/descriptionCollapse";
import googleMap from "./lib/googleMap";
import applicationReset from "./lib/applicationReset";
import apartmentHeroCarousel from "./lib/apartmentHeroCarousel";
import InlineSvg from "./vue/components/InlineSvg.vue";
import SiteHeaderMobile from "./vue/SiteHeaderMobile.vue";
import StandaloneApartmentCard from "./vue/StandaloneApartmentCard.vue";
import FavouritesDropdown from "./vue/FavouritesDropdown.vue";
import SearchDropdown from "./vue/SearchDropdown.vue";
import ApplicationRent from "./vue/ApplicationRent.vue";
import ApplicationOwnerOccupancy from "./vue/ApplicationOwnerOccupancy.vue";
import ApplicationRightOfOccupancy from "./vue/ApplicationRightOfOccupancy.vue";
import ImageSlider from "./vue/ImageSlider.vue";
import FavouriteToggle from "./vue/FavouriteToggle.vue";
import ApartmentSearchFull from "./vue/ApartmentSearchFull.vue";
import ApartmentSearchFullAllTypes from "./vue/ApartmentSearchFullAllTypes.vue";
import StandaloneApartmentSearchForm from "./vue/StandaloneApartmentSearchForm.vue";
import StandaloneApartmentSearchFormMinimal from "./vue/StandaloneApartmentSearchFormMinimal.vue";
import PopupMap from "./vue/PopupMap.vue";
// import Map from "./vue/Map.vue";
import PopupVirtual from "./vue/PopupVirtual.vue";
import ContactInfoSearch from "./vue/ContactInfoSearch.vue";
import HousingLocalityApartments from "./vue/HousingLocalityApartments.vue";
import HousingLocalityApartmentsAvailable from "./vue/HousingLocalityApartmentsAvailable.vue";
import RelatedItems from "./vue/RelatedItems.vue";
import HousingLocalityGroup from "./vue/HousingLocalityGroup.vue";
import CampaignItemsList from "./vue/CampaignItemsList.vue";
import HousingLocalitySliderCard from "./vue/HousingLocalitySliderCard";
import ApplicationActivityTimer from "./vue/ApplicationActivityTimer";
import PickPostCard from "./vue/PickPostCard";
import Gallery from "./vue/Gallery";
import GallerySlideshow from "./vue/GallerySlideshow";

window.initGoogleMap = googleMap.init;

// Global components to be registered in every Vue app instance
const globalComponents = {
  InlineSvg,
};

// Init Vue root components
vueComponents.init({
  SiteHeaderMobile,
  StandaloneApartmentCard,
  FavouritesDropdown,
  SearchDropdown,
  ApplicationRent,
  ApplicationRightOfOccupancy,
  ApplicationOwnerOccupancy,
  ImageSlider,
  FavouriteToggle,
  ApartmentSearchFull,
  ApartmentSearchFullAllTypes,
  StandaloneApartmentSearchForm,
  StandaloneApartmentSearchFormMinimal,
  PopupMap,
  // Map, // Simple map.
  PopupVirtual,
  ContactInfoSearch,
  HousingLocalityApartments,
  HousingLocalityApartmentsAvailable,
  RelatedItems,
  HousingLocalityGroup,
  CampaignItemsList,
  HousingLocalitySliderCard,
  ApplicationActivityTimer,
  PickPostCard,
  // Gallery
  Gallery,
  GallerySlideshow
}, globalComponents);

drawer.init();
//headroom.init();
modal.init();
descriptionCollapse.init();
applicationReset.init();

// Initialize A11y Dialog for megamenu.
const container = document.querySelector('#avain-megamenu');
const dialog = new A11yDialog(container);

// Prevent scrolling when megamenu is open.
// See https://a11y-dialog.netlify.app/advanced/scroll-lock
dialog
  .on('show', () => (document.documentElement.style.overflowY = 'hidden'))
  .on('hide', () => (document.documentElement.style.overflowY = ''))

// Apartment hero carousel init. Runs its own Swiper instances, see the generic init below.
document.addEventListener('DOMContentLoaded', function () {
  apartmentHeroCarousel.init();
});

// Swiper init. Carousels that configure Swiper themselves opt out with data-swiper-skip-global.
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper:not([data-swiper-skip-global])', {
    // Configure Swiper to use modules: https://swiperjs.com/swiper-api#using-js-modules
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    loop: true,
    slidesPerView: 1,
    grabCursor: true,
    effect: 'fade',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 5000,
    },
  });
});

// Initialize Bootstrap Popover: hover bridge on desktop, click toggle for touch / dev-tools mobile.
const POPOVER_HIDE_DELAY_MS = 300;

function initHoverPopover(triggerEl) {
  let hideTimeout = null;
  let openedByClick = false;

  const popover = new Popover(triggerEl, {
    trigger: 'manual',
  });

  const isShown = () => triggerEl.getAttribute('aria-describedby') !== null;

  const getTip = () => {
    const tipId = triggerEl.getAttribute('aria-describedby');
    return tipId ? document.getElementById(tipId) : null;
  };

  const cancelHide = () => clearTimeout(hideTimeout);

  const scheduleHide = () => {
    if (openedByClick) {
      return;
    }

    cancelHide();
    hideTimeout = setTimeout(() => popover.hide(), POPOVER_HIDE_DELAY_MS);
  };

  const showPopover = () => {
    cancelHide();
    popover.show();
  };

  const hidePopover = () => {
    cancelHide();
    openedByClick = false;
    popover.hide();
  };

  triggerEl.addEventListener('mouseenter', showPopover);
  triggerEl.addEventListener('mouseleave', scheduleHide);
  triggerEl.addEventListener('focus', showPopover);
  triggerEl.addEventListener('blur', scheduleHide);

  triggerEl.addEventListener('click', (event) => {
    event.preventDefault();

    cancelHide();

    if (isShown()) {
      hidePopover();
      return;
    }

    openedByClick = true;
    popover.show();
  });

  document.addEventListener('click', (event) => {
    if (!openedByClick || !isShown()) {
      return;
    }

    const tip = getTip();

    if (triggerEl.contains(event.target) || tip?.contains(event.target)) {
      return;
    }

    hidePopover();
  });

  triggerEl.addEventListener('shown.bs.popover', () => {
    const tip = getTip();
    if (!tip) {
      return;
    }

    const onTipEnter = () => cancelHide();
    const onTipLeave = () => scheduleHide();

    tip.addEventListener('mouseenter', onTipEnter);
    tip.addEventListener('mouseleave', onTipLeave);

    triggerEl.addEventListener(
      'hidden.bs.popover',
      () => {
        openedByClick = false;
        tip.removeEventListener('mouseenter', onTipEnter);
        tip.removeEventListener('mouseleave', onTipLeave);
      },
      { once: true },
    );
  });
}

const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
[...popoverTriggerList].forEach(initHoverPopover);
